import { useEffect } from "react"
import { brandAppName } from "~/common/brand"

const defaultTitle = `${brandAppName()}: Crash the Group Chat`
const defaultDescription =
  "Epic group chats hosted by your favorite podcasters, politicos, reality stars, athletes, comedians & more"

const setMetaContent = (selectors: string[], content: string) => {
  selectors.forEach((selector) =>
    document.querySelector(selector)?.setAttribute("content", content)
  )
}

export const useDocumentTitleDescription = (
  title: string | null = defaultTitle,
  description: string | null = defaultDescription
) => {
  useEffect(() => {
    if (title != null) {
      document.title = title
      setMetaContent(["meta[property='og:title']", "meta[name='twitter:title']"], title)
    }
    if (description != null) {
      setMetaContent(
        [
          "meta[name='description']",
          "meta[property='og:description']",
          "meta[name='twitter:description']",
        ],
        description
      )
    }
  }, [title, description])
}
